import { Message } from 'element-ui';

let messageInstance = null;
const resetMessage = (options) => {
  if (messageInstance) {
    messageInstance.close()
  }
  messageInstance = Message(options)
};

['error', 'success', 'info', 'warning'].forEach(type => {
    resetMessage[type] = options => {
      // 处理字符串参数，转换为对象格式
      if (typeof options === 'string') {
        options = {
          message: options
        }
      }
      // 确保 options 是一个对象，如果是 null 或 undefined 则初始化为空对象
      if (options == null) {
        options = {}
      }
      options.type = type
      return resetMessage(options)
    }
  })
 
export default resetMessage
